export default function gomsFulfillmentApi(fetch, baseUrl) {
  return {
    getAllFulfillment(reqBody) {
      return fetch.post(`${baseUrl}/goms/search`, reqBody);
    },

    getFulfillmentById({ fulfillmentId }) {
      return fetch.get(`${baseUrl}/${fulfillmentId}`);
    },

    forceInitiateFulfillment({ fulfillmentId }) {
      return fetch.post(`${baseUrl}/force-initiate/${fulfillmentId}`);
    },

    forceInitiateGomsFulfillmentWithRelease({ orderId, release }) {
      return fetch.post(`${baseUrl}/goms/trm-update`, { orderId, release });
    }
  };
}